/* eslint-env browser */
/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-02
 */

import {httpClientBackend, httpClient} from './http-client';
import {procedureListRequest, procedureCountStatusRequest} from '@/api/models';

/**
 * Obtiene el listado de tramites realizados por el usuario, pudiendo filtrar por estatus
 *
 * @param request
 * @returns {Promise<AxiosResponse<any>>}
 */
const getListByUser = (request = procedureListRequest()) => {
    const storedUserId = localStorage.getItem('userId');

    if (!storedUserId) {
        return Promise.reject(new Error('userId no existe en localStorage'));
    }

    return httpClientBackend.get(`/tramites_usuario/${storedUserId}/${request.status}`, {
        params: {
            page: request.page,
            limit: request.limit,
            invited: request.invited,
            session_user: request.sessionUser,
            query: request.query
        }
    });
};


/**
 * Obtiene el conteo de tramites por cada estatus
 *
 * @param request
 * @returns {Promise<AxiosResponse<any>>}
 */
const getStatusCount = (request = procedureCountStatusRequest()) => {
    const storedUserId = localStorage.getItem('userId');

    if (!storedUserId) {
        return Promise.reject(new Error('userId no existe en localStorage'));
    }

    return httpClientBackend.get(
        `/tramites_usuario_count/${storedUserId}/${request.sessionUser}/${request.invited}`
    );
};


/**
 * Inicializa un nuevo tramite
 *
 * @param processId
 * @param invited
 * @param sessionUser
 * @returns {Promise<AxiosResponse<any>>}
 */
const getStartNew = (processId, invited, sessionUser) =>
    httpClient.get(`tramite_iniciar/${processId}/${invited}/${sessionUser}`);

/**
 * Obtienes el listado de pasos de una tarea
 *
 * @param taskId
 * @param stageId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getTaskSteps = (taskId, stageId) =>
    httpClientBackend.get(`tareas/${taskId}/pasos?stage_id=${stageId}`);

/**
 * Obtiene valores dinammicos para los campos de tipo Select en el formulario
 *
 * @param stageId
 * @param fieldId
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
const getFormSelectValues = (stageId, fieldId, params) =>
    httpClientBackend.get(`get_values_select/${stageId}/${fieldId}/1?${params}`);

/**
 * Ejecuta siguiente/atrás del formulario del trámite
 *
 * @param url
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const postExecuteForm = (url, data) => httpClient.post(url, data);

/**
 * Ejecuta siguiente/atrás del formulario del trámite
 *
 * @param url
 * @returns {Promise<AxiosResponse<any>>}
 */
const getExecuteForm = (url) => httpClient.get(url);

/**
 * Realiza la continuación de un trámite
 *
 * @param stageId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getContinueStage = (stageId) => httpClient.get(`etapa_ejecutar/${stageId}/0`);

/**
 * Realiza la continuación del trámite en modo Vista
 *
 * @param stageId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getViewStage = (stageId) => httpClient.get(`etapa_ver/${stageId}/0`);

/**
 * Obtiene el resultado de ejecutar el botón submit
 *
 * @param stageId
 * @param fieldId
 * @returns {Promise<AxiosResponse<any>>}
 */
const getSubmitRequest = (stageId, fieldId) =>
    httpClientBackend.get(`send_request?stage_id=${stageId}&field_id=${fieldId}`);

const getApiAjaxResult = (request) =>
    httpClientBackend.get('ajax_get_data', {params: request});

export {
    getListByUser,
    getStatusCount,
    getStartNew,
    getFormSelectValues,
    getTaskSteps,
    getContinueStage,
    getViewStage,
    postExecuteForm,
    getExecuteForm,
    getSubmitRequest,
    getApiAjaxResult
};